var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgQrSidebar = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M11 24H3a2 2 0 0 1-2-2v-8h10zm-9-2a1 1 0 0 0 1 1h7v-8H2z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M24 14v7.5a2.5 2.5 0 0 1-2.5 2.5H14v-6h6v1h-5v4h6.5a1.5 1.5 0 0 0 1.5-1.5V14zM20 14v1h-6v-1z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M11 11H1V3a2 2 0 0 1 2-2h8zM3 2a1 1 0 0 0-1 1v7h8V2zM22 1a2 2 0 0 1 2 2v8H14V1zm-7 9h8V3a1 1 0 0 0-1-1h-7z",
  clipRule: "evenodd"
})));
export default SvgQrSidebar;